<div class="results" data-element="results-list">

  <!-- 'pending' — a run is in flight. Distinct from 'empty': slow must never read as "no trades" (§11). -->
  <div class="run-status pending" *ngIf="this.isPending">
    <dx-load-indicator [height]="18" [width]="18"></dx-load-indicator>
    <span class="msg">Analyzing…</span>
  </div>

  <!-- 'empty' — a VALID "no trades" answer. Calm by design, NOT an error (§6). -->
  <div class="empty-state" *ngIf="this.isEmpty" data-element="results-empty-state">
    <i class="fas fa-info-circle"></i>
    <div class="title">No Trades Matched Your Inputs</div>
    <!-- CR-20260902-001: when ORION can say WHY (e.g. the expected range ends at/below the start
         strike), print its sentence(s) instead of the generic advice. -->
    <div class="msg note" *ngIf="this.emptyNote" data-element="results-empty-note">{{this.emptyNote}}</div>
    <div class="msg" *ngIf="!this.emptyNote">ORION Ran Successfully But Found no Trades For These Inputs. Adjust Your Inputs And Run Again.</div>
  </div>

  <!-- 'terminalFailed' — throw or backstop stall; "please try again" tone (§11). -->
  <div class="failed-state" *ngIf="this.isFailed" data-element="results-failed-state">
    {{this.failureText}}
  </div>

  <!-- 'succeeded' — call results LEFT, put results RIGHT, NEVER mixed in one line (§6/§10);
       single-side tabs render one column. Each side is ONE trade stack — rendered verbatim
       (courier §6). -->
  <div class="columns" #columnsSection [class.dual]="this.isDual"
       [style.minHeight.px]="this.columnsLockedHeightPx"
       [class.calls-collapsed]="this.callsRailVisible"
       [class.puts-collapsed]="this.putsRailVisible"
       *ngIf="this.hasResults">

    <!-- Collapsed calls side: same click-to-expand rail idiom as the questionnaire — bare side
         name, no "collapsed" word (owner, WI-12 review). WI-16/A8: this rail expands the RESULTS
         side only; the questionnaire's own collapse state is untouched. -->
    <div class="side-rail" *ngIf="this.callsRailVisible" data-element="results-calls-rail"
         title="Expand This Side" (click)="this.onRailClicked('calls')">
      <span class="rail-text">Calls</span>
    </div>

    <div class="side-column" *ngIf="this.showCallsColumn && !this.callsRailVisible" data-element="results-calls-column">
      <!-- No sample-data chip (BF-4/A4): mock provenance lives in the trade names only.
           WI-16/A8: on the dual tab the WHOLE header row is this side's COLLAPSE control (the
           questionnaire's WI-12 target, duplicated) — post-Run the questionnaire is hidden behind
           the breadcrumb, so before this the results had a rail that could only EXPAND and no way
           to collapse. Single-side tabs: the same row is a plain, inert label. -->
      <div class="side-header" [class.collapsible]="this.isDual"
           data-element="results-calls-collapse-toggle"
           [title]="this.isDual ? 'Collapse This Side' : ''"
           (click)="this.onCollapseClicked('calls')">
        <span class="side-name">Calls</span>
      </div>
      <!-- WI-7: the result renders as a member stack + a gated Load-All bar (the bar disables
           for a mixed-expiration remaining set; a single-date set loads in one navigate). -->
      <ets-opg-trade-stack
        *ngIf="this.callsResult"
        [members]="this.callsResult.members"
        [root]="this.root"
        [loadedPriceOf]="this.loadedPriceOf"
        [showLoadAll]="this.showLoadAll"
        (previewToggled)="this.onPreviewToggled($event)"
        (loadAllRequested)="this.onLoadAllRequested($event)"
        (unPreviewAllRequested)="this.onUnPreviewAllRequested($event)"
      ></ets-opg-trade-stack>
      <!-- Side absent from a succeeded run = that side's legitimate "no trades" (§6).
           CR-20260902-001: with a skill note, the note replaces the generic line. -->
      <div class="side-empty" [class.note]="!!this.callsNote" *ngIf="!this.callsResult">{{this.callsNote || 'No Trades For This Side.'}}</div>
    </div>

    <!-- Collapsed puts side (§6): same rail idiom. -->
    <div class="side-rail" *ngIf="this.putsRailVisible" data-element="results-puts-rail"
         title="Expand This Side" (click)="this.onRailClicked('puts')">
      <span class="rail-text">Puts</span>
    </div>

    <div class="side-column" *ngIf="this.showPutsColumn && !this.putsRailVisible" data-element="results-puts-column">
      <!-- Collapse control on the dual tab; inert label on a single-side tab (see the calls side). -->
      <div class="side-header" [class.collapsible]="this.isDual"
           data-element="results-puts-collapse-toggle"
           [title]="this.isDual ? 'Collapse This Side' : ''"
           (click)="this.onCollapseClicked('puts')">
        <span class="side-name">Puts</span>
      </div>
      <!-- WI-7: the result renders as a member stack + a gated Load-All bar (the bar disables
           for a mixed-expiration remaining set; a single-date set loads in one navigate). -->
      <ets-opg-trade-stack
        *ngIf="this.putsResult"
        [members]="this.putsResult.members"
        [root]="this.root"
        [loadedPriceOf]="this.loadedPriceOf"
        [showLoadAll]="this.showLoadAll"
        (previewToggled)="this.onPreviewToggled($event)"
        (loadAllRequested)="this.onLoadAllRequested($event)"
        (unPreviewAllRequested)="this.onUnPreviewAllRequested($event)"
      ></ets-opg-trade-stack>
      <div class="side-empty" [class.note]="!!this.putsNote" *ngIf="!this.putsResult">{{this.putsNote || 'No Trades For This Side.'}}</div>
    </div>

  </div>

</div>
